module.exports = __webpack_public_path__ + "static/media/searchicon-grey.de4a4dfc.svg";